module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"head":{"meta":{"title":"募集情報一覧","description":"企業の募集情報を検索することができます。 求人情報だけでなく、経営理念や将来のビジョン、先輩たちが社会に出てどのように、どんな思いで働いているのかをお届けします。 その情報が、あなたの「はたらく目的」を発見する機会になるように。\\n"}}}}')
  delete Component.options._Ctor
}
